export const ALPHA_NUMERIC_SPACE_REGEX = /^[A-Z0-9\s]+$/i;
export const ALPHA_NUMERIC_REGEX = /^[A-Z0-9]+$/i;
export const NUMERIC_REGEXP = /^\d+$/;
export const INTEGER_REGEXP = /^-?\d*$/;
export const INTEGER_POSITIVE_REGEXP = /^[1-9]\d*$/;
export const FLOAT_REGEXP = /^-?\d*(?:\.\d*)?$/;
export const FLOAT_NOT_NEGATIVE_REGEXP = /^\d*(?:\.\d*)?$/;
export const PHONE_REGEXP = /^[0-9\-()+\s]+$/;
export const EMAIL_REGEXP = /^[\w.%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const getFloatingNumberRegexp = (fraction?: number) => new RegExp(`^-?\\d*(?:\\.\\d{0,${fraction ?? 2}})?$`);

export const arrayFieldBracketRegexp = /\[|\]./;
export const arrayBracketsIndexRegexp = /\[\d+\]/;
export const arrayDotIndexRegexp = /\.\d+./;

export const UTC_REGEXP = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{2,3}Z$/;
